import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import Immutable from "immutable";

export default class SpecialBillFormClockTC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            placementTaskId: null,
            taskDetails: [],
            disableControls: false
        }

        this.setSelectedValue = this.setSelectedValue.bind(this);
        this.getSpecialBill = this.getSpecialBill.bind(this);
        this.updateTaskId = this.updateTaskId.bind(this);
    }

    updateTaskId(newId, setSelectedValue = false) {
        const self = this;
        const clone = Immutable.fromJS(this.state).toJS();
        clone.setSelectedValue = setSelectedValue;
        if (newId && (newId.length > 0 || newId > 0)) {
            ajax.api()
                .get(`get-placement-task-picklists/${newId}`)
                .then(function (res) {
                    let data = res.data;
                    clone.placementTaskId = newId;
                    clone.taskDetails = data;

                    if (self.props.specialBill && self.props.taskId == newId) {
                        for (let k in self.props.specialBill) {
                            for (let i = 0; i < clone.taskDetails.length; i++) {
                                let td = clone.taskDetails[i];
                                if (k.toLowerCase() === td.placementTaskDetail.taskCode.toLowerCase()) {
                                    td.selectedValue = self.props.specialBill[k];
                                    break;
                                }
                            }
                        }
                    }
                    if (self.props.shouldDisable) {
                        if (self.props.shouldDisable === "yes") {
                            clone.disableControls = true;
                        }
                        else {
                            clone.disableControls = false;
                        }

                    }
                    self.setState(clone);
                });
        } else {
            clone.placementTaskId = null;
            clone.taskDetails = [];
            self.setState(clone);
        }
    }

    getSpecialBillWithRequired() {
        const result = {};
        for (let i = 0; i < this.state.taskDetails.length; i++) {
            const td = this.state.taskDetails[i];
            result[`${td.placementTaskDetail.taskCode.toLowerCase()}`] = {
                value: td.selectedValue === undefined ? null : td.selectedValue,
                isRequired: td.placementTaskDetail.required
            }
        }
        console.log(result);
        return result;
    }

    getSpecialBill() {
        const result = {};
        for (let i = 0; i < this.state.taskDetails.length; i++) {
            const td = this.state.taskDetails[i];
            result[`${td.placementTaskDetail.taskCode.toLowerCase()}`] = td.selectedValue === undefined ? "" : td.selectedValue;
        }
        console.log(result);
        return result;
    }

    setSelectedValue(taskDetailId, value) {
        for (let i = 0; i < this.state.taskDetails.length; i++) {
            const td = this.state.taskDetails[i];
            if (td.placementTaskDetail.placementTaskDetailId === taskDetailId) {
                td.selectedValue = value;
                break;
            }
        }
    }

    componentDidMount() {
        if (this.props.taskId) {
            this.updateTaskId(this.props.taskId, true);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.taskId != this.props.taskId) {
            this.updateTaskId(nextProps.taskId, true);
        }
        if(nextProps.shouldDisable==="yes"){
            this.updateTaskId(nextProps.taskId, true);
        }
    }

    render() {
        const self = this;
        const taskId = this.state.placementTaskId;
        let content = null;
        if (taskId) {
            let picklist = this.state.taskDetails.map(td => {
                const requiredMark = td.placementTaskDetail.required ? (<span className="ap-color-red">*</span>) : null;

                let control = td.placementTaskDetail.pickList == 1 ?
                    <FormControl componentClass="select" disabled={this.state.disableControls ? true : false} onChange={(evt) => this.setSelectedValue(td.placementTaskDetail.placementTaskDetailId, evt.target.value)}
                        defaultValue={td.selectedValue}>
                        <option key="" value="">Please select...</option>
                        {td.pickList.map(pl => <option key={pl.placementTaskDetailPickListID} value={pl.taskValue}>{pl.taskValue}</option>)}
                    </FormControl> :
                    <FormControl disabled={this.state.disableControls ? true : false} onChange={(evt) => this.setSelectedValue(td.placementTaskDetail.placementTaskDetailId, evt.target.value)}
                        defaultValue={td.selectedValue}>
                    </FormControl>;

                return (<div className="row" key={td.placementTaskDetail.placementTaskDetailId}>
                    <div className="col-md-2 col-lg-2 text-right hidden-sm hidden-xs">
                        <ControlLabel>{td.placementTaskDetail.taskCode} {requiredMark}</ControlLabel>
                    </div>
                    <div className="col-xs-12 col-sm-12 hidden-md hidden-lg">
                        <ControlLabel>{td.placementTaskDetail.taskCode} {requiredMark}</ControlLabel>
                    </div>
                    <div className="col-md-10 col-lg-10 col-xs-12 col-sm-12">
                        {control}
                    </div>
                </div>);
            });
            content = (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <hr />
                            <span className="ap-h3">Special Bill</span>
                        </div>
                        <div className="col-md-12 ap-top-margined">&nbsp;</div>
                    </div>
                    {picklist}
                </div>
            );
        } else {
            content = []
            for (let key in self.props.specialBill) {
                content.push(
                    <FormControl disabled={this.state.disableControls ? true : false} defaultValue={self.props.specialBill[key]} />
                );
            }
        }
        return (
            <div>
                {content}
            </div>
        );
    }
}